import {Col, DatePicker, Form, Input, Row, Select} from 'antd';
import React from 'react';
import AddFormComponent from '../common/AddFormComponent';
import EditFormComponent from '../common/EditFormComponent';
import {Arguments} from '../common/Arguments';
import SaveButtonComponent from '../common/SaveButtonComponent';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';

const layout = {
	labelCol: {span: 10},
	wrapperCol: {span: 14},
};

const tailLayout = {
	wrapperCol: {offset: 5, span: 16},
};

const AddGroupBranchParties = () => {
	const currentUrl = window.location.href;
	const apiList = [Arguments.host + '/society_organization/society/api!addMemberPersonal.do'];

	return (currentUrl.endsWith('add') ? <AddFormComponent UserForm={BranchPartiesForm} url={apiList}/> :
		<EditFormComponent UserForm={BranchPartiesForm} url={apiList}/>);
};

const BranchPartiesForm = ({onFinish, initialValues}) => {
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			initialValues={initialValues}
			style={{maxWidth: 800, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={12}>
					<Form.Item name="memberName" label="姓名"
							   rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input disabled={window.location.href.endsWith('edit')}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="memberBorn" label="出生日期"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<DatePicker placeholder="选择日期" disabled={window.location.href.endsWith('edit')}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 5}}
						wrapperCol={{span: 19}}
						name="memberUnit" label="工作单位（或原）"
						rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input disabled={window.location.href.endsWith('edit')}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="memberEducational" label="学历"
							   rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="本科">
						<Select disabled={window.location.href.endsWith('edit')}>
							<Select.Option value="中专及以下">中专及以下</Select.Option>
							<Select.Option value="大专">大专</Select.Option>
							<Select.Option value="本科">本科</Select.Option>
							<Select.Option value="硕士">硕士</Select.Option>
							<Select.Option value="博士">博士</Select.Option>
						</Select>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="memberDate" label="入党日期">
						<DatePicker placeholder="选择日期"/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 5}}
						wrapperCol={{span: 19}}
						name="memberZzgxUnit" label="组织关系所在单位">
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<SaveButtonComponent/>
			</Form.Item>
		</Form>
	);
};

export default AddGroupBranchParties;
